<template>
    <div class="lni-c-janitorial-workload-calculator lni-c-box--content lni-u-mhauto lni-u-mv3">
        <div
            v-show="isLoading"
            class="lni-u-text--center"
        >
            <lni-spinner
                id="home_page-spinner"
            />
        </div>
        <!-- TODO: Error messages -->
        <div class="lni-u-mb2">
            <h1 class="lni-u-heading--1">
                {{ content?.title }}
            </h1>
            <lni-html-element
                id="home-usage"
                class="lni-u-mt3 lni-u-reading-width--max"
            />
            <div class="lni-u-mt3">
                <h2 class="lni-u-heading--2">
                    {{ content?.managementHeading }}
                </h2>
                <div class="lni-u-mt2">
                    <button
                        class="lni-c-button --caret lni-u-text--all-caps"
                        @click="goTo('/job-plan', types.Job)"
                    >
                        {{ content?.jobPlanLabel }}
                    </button>
                    <button
                        class="lni-c-button --caret lni-u-text--all-caps lni-u-block lni-u-mt2"
                        @click="goTo('/job-plan', types.Management)"
                    >
                        {{ content?.managementReportLabel }}
                    </button>
                </div>
            </div>
            <div class="lni-u-mt3">
                <h2 class="lni-u-heading--2">
                    {{ content?.ergonomicHeading }}
                </h2>
                <button
                    class="lni-c-button --caret lni-u-text--all-caps lni-u-mt2"
                    @click="goTo('/job-plan', types.Ergonomic)"
                >
                    {{ content?.ergonomicEvaluationLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

import Types from '@gov.wa.lni/application.janitorial-workload-calculator/source/logic/enums/types';

export default {
    name: 'LniHomePage',
    computed: {
        content() {
            return this.$store.state.appState?.content;
        },
        isLoading() {
            return this.$store.state.appState?.isLoading;
        },
        types() {
            return Types;
        },
        ...mapGetters({
            contentGenericIds: 'appState/contentGenericIds',
            contentId: 'appState/contentId',
        }),
    },
    mounted() {
        this.$nextTick(() => {
            // Set text from JSON content
            this.$store.dispatch('getText', {
                oneLni: this.$oneLni,
                id: this.contentId,
            }).then(text => {
                for (const [key, value] of Object.entries(text)) {
                    this.$store.commit('appState/SET_CONTENT', {
                        key,
                        value,
                    });
                }
            });

            this.$store.dispatch('getContent', {
                oneLni: this.$oneLni,
                ids: this.contentGenericIds,
            }).then(contentlets => {
                // Set content generics
                const entries = new Map(Object.entries(this.contentGenericIds));
                for (const [key, value] of entries) {
                    const body = contentlets.find(contentlet => contentlet.identifier === value).body;
                    this.$store.commit('appState/SET_CONTENT', {
                        key,
                        value: body,
                    });
                }

                this.$store.commit('setAttribute', {
                    id: 'home-usage',
                    attribute: 'htmlString',
                    value: this.$store.state.appState.content.usage,
                }, {
                    root: true,
                });

                this.$nextTick(() => {
                    this.$store.commit('appState/SET_VALUE', {
                        key: 'isInitialized',
                        value: true,
                    });
                    this.$store.commit('appState/SET_VALUE', {
                        key: 'isLoading',
                        value: false,
                    });
                });
            });
        });
    },
    methods: {
        goTo(path, type) {
            this.$store.commit('appState/SET_VALUE', {
                key: 'type',
                value: type,
            });
            this.$router.push(path);
        },
    },
}; </script>